import css from "../../css/listing/agent.module.css";

import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";

import phoneLinkFormatter from "../../helper/phoneLinkFormatter";
import Avatar from "../agents/Avatar";
import isRent from "../../helper/isRent";
import useMobile from "../../hooks/useMobile";
import {
    isTeam,
    getTeamAgentProfilePageUrl,
    getTeamProfilePageUrl,
    isForwardTeamLeaderProfileToTeam,
} from "../../service/team_page";
import { THUMB_150_150 } from "../../service/photo";

const Agent = (props) => {
    const { agent, listing, isPrimary, isMarketShareAgent } = props;
    const isMobile = useMobile();

    let title = isPrimary
        ? isRent(listing)
            ? "Leasing Agent"
            : "Listing Agent"
        : "Local Real Estate Expert";

    if (isMarketShareAgent) {
        title = "Local Real Estate Expert";
    }

    const isTeamPage = isTeam(agent);
    const agentProfilePageUrl = getTeamAgentProfilePageUrl(agent);
    const teamProfilePageUrl = getTeamProfilePageUrl(agent);
    const isForwardTeamLeaderProfileToTeamProfile =
        isForwardTeamLeaderProfileToTeam(agent);

    return (
        <div className={css.agent}>
            <div className={css.photo}>
                <Avatar photo={agent.photo} size={THUMB_150_150} />
            </div>
            <div>
                <div className={css.name}>
                    {isTeamPage ? agent.first_name : agent.full_name}
                </div>
                {isTeamPage && (
                    <div className={css.type}>Team</div>
                )}
                <div className={css.type}>{title}</div>
                {agent.phone_primary && !isMobile && (
                    <div className={css.phone}>{agent.phone_primary}</div>
                )}
                <div className={css.buttons}>
                    <Link
                        href={agentProfilePageUrl.href}
                        as={agentProfilePageUrl.as}
                        className={css.buttonProfile}
                    >
                        View Profile
                    </Link>
                    {agent.phone_primary && isMobile && (
                        <a
                            href={phoneLinkFormatter(agent.phone_primary)}
                            className={css.buttonCall}
                        >
                            Call Agent
                        </a>
                    )}
                    {!isForwardTeamLeaderProfileToTeamProfile &&
                        teamProfilePageUrl && (
                            <Link
                                href={teamProfilePageUrl.href}
                                as={teamProfilePageUrl.as}
                                className={css.buttonTeamProfile}
                            >
                                Team Profile
                            </Link>
                        )}
                </div>
            </div>
            <div className={css.clear} />
        </div>
    );
};

Agent.propTypes = {
    agent: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
    isPrimary: PropTypes.bool.isRequired,
    isMarketShareAgent: PropTypes.bool,
};

Agent.defaultProps = {
    isMarketShareAgent: null,
};

export default Agent;
